<template>
    <div>
    <section-header />
    
        <section class="about-section-two">
              <div class="auto-container">
                  <div class="inner-container">
                      <div class="row clearfix">
                          <!--Column-->
                          <div class="content-column col-md-6 col-sm-12 col-xs-12">
                              <div class="inner-content">
                                  <div class="text">
                                      <p>Here is a non-exhaustive list of our services. If you do not find what you need in this list, please  contact us so that we can discuss your request and help you find a solution.</p>
                                      <p>&nbsp;</p>
                                  </div>
                                  <div id="activities-managed-in-house" class="dark-text">Activities managed in house :</div>
                                  <div class="text">
                                      <ul class="list-style-three">
                                          <li>Project management
                                              <ul class="list-style-five">
                                                  <li>Project Plan</li>
                                                  <li>Protocol and documents design</li>
                                                  <li>Sites selection and recruitment</li>
                                                  <li>Sites management</li>
                                                  <li>Vendors management</li>
                                                  <li>Regulatory and EC Submissions</li>
                                                  <li>Study insurance</li>
                                                  <li>CTMS</li>
                                                  <li>eTMF & eSMF</li>
                                                  <li>Communication: meetings, newsletters, reports etc…</li>
                                              </ul>
                                          </li>
                                          <li>Project oversight</li>
                                          <li>Budget and Contracts negotiations</li>
                                          <li>QA & QC, GCP and GDPR compliance, audit preparation</li>
                                      </ul>
                                  </div>
                                  <div class="text">
                                    <p>&nbsp;</p>
                                  </div>
                                  <div id="collaboration-with-our-trusted-partners" class="dark-text">Collaboration with our trusted partners :</div>
                                  <ul class="list-style-three">
                                      <li>Regulatory Submission  in EU countries (other than FR)</li>
                                      <li>eCRF & ePRO</li>
                                      <li>Monitoring</li>
                                      <li>Data management</li>
                                      <li>Pharmacovigilance</li>
                                      <li>Statistical Analysis</li>
                                      <li>IMP Relabelling and Distribution</li>
                                      <li>Central Lab and samples shipment</li>
                                  </ul>
                                  <div class="text">
                                    <p>&nbsp;</p>
                                  </div>
                                  <div id="financial-services-in-house-managed" class="dark-text">Financial services in house managed :</div>
                                  <ul class="list-style-three">
                                      <li>Budget set up for global study including hospital/site participating fees</li>
                                      <li>Contracts negotiations with private or academic partners</li>
                                      <li>Capacity to sign as sponsor representative vendor and sites agreement</li>
                                      <li>Capacity to make the study payments</li>
                                  </ul>


                              </div>
                          </div>
                          <!--Column-->
                          <div class="image-column col-md-6 col-sm-12 col-xs-12">
                              <div class="image">
                                  <img src="images/resource/bcom/service.jpg" alt="" />
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
        </section>
        </div>
</template>

<script>
import SectionHeader from '@/components/SectionHeader.vue';

export default {
  name: 'Services',
  components: {
    SectionHeader
  },
  data() {
    return {
      content: '',
      hash: this.$route.hash,
    };
  },
  computed: {
   currentPa() {
        return this.$router.history.current.name;
      },
  },
  mounted() {

    this.$nextTick(function () { // this.$nextTick() to wait for DOM updated.
        if (this.hash) {
            const refName = this.hash.replace('#', '');
            const el = document.getElementById(refName);

            const yOffset = -90;
            const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
        }
    });


  }
};
</script>